import { useCallback, useEffect, useRef, useState } from 'react';

export default function useInvoiceConfirmation() {
    const [confirmation, setConfirmation] = useState(null);
    const resolverRef = useRef(null);
    const requestConfirmation = useCallback(options => new Promise(resolve => {
        if (resolverRef.current) { resolve(false); return; }
        resolverRef.current = resolve;
        setConfirmation(options);
    }), []);
    const resolveConfirmation = useCallback(accepted => {
        const resolve = resolverRef.current;
        resolverRef.current = null;
        setConfirmation(null);
        resolve?.(accepted);
    }, []);
    useEffect(() => () => {
        // A closed workspace must never resume a pending replacement.
        resolverRef.current?.(false);
        resolverRef.current = null;
    }, []);
    return { confirmation, requestConfirmation, resolveConfirmation };
}
